import { render, staticRenderFns } from "./PageOrdersBooking.vue?vue&type=template&id=1dfa01d6&"
import script from "./PageOrdersBooking.vue?vue&type=script&lang=js&"
export * from "./PageOrdersBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dfa01d6')) {
      api.createRecord('1dfa01d6', component.options)
    } else {
      api.reload('1dfa01d6', component.options)
    }
    module.hot.accept("./PageOrdersBooking.vue?vue&type=template&id=1dfa01d6&", function () {
      api.rerender('1dfa01d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ordersBooking/PageOrdersBooking.vue"
export default component.exports